import {addEditBillingGroupActionTypes} from "../constants/AddEditActionConstants";
import _ from "lodash";

const initialState = {
    editBillingGroup: false,
    toggleModal: false,
    updatedBillingGroup: false,
    billingGroupObject: {
        billing_group_name: "",
        billing_period: null,
        cancel_days_notice: null,
        contract_start_date: null,
        contract_term: null,
        created_date: "",
        currency: "USD",
        id: "",
        invoice_name: "",
        is_deleted: false,
        last_updated: "",
        match_rules_id: null,
        monthly_aggregate_volume: null,
        price_model: "",
        description: "",
        tier_type: null,
        updated_by: "",
        auto_renew: true,
        volume_aggregation_type: "",
        platform_fee: 0.00,
        base_price: 0,
    }
}

const addEditBillingGroupReducer = (state = initialState, action) => {
    switch (action.type) {

        case addEditBillingGroupActionTypes.EDIT_ONE_BILLING_GROUP: {
            let newState = _.cloneDeep(state);
            newState.editBillingGroup = !initialState.editBillingGroup;
            newState.toggleModal = !initialState.toggleModal;
            newState.billingGroupObject = action.payload.billingGroupDetail;
            return newState;
        }

        case addEditBillingGroupActionTypes.ADD_BILLING_GROUP: {
            let newState = _.cloneDeep(state);
            newState.toggleModal = !initialState.toggleModal;
            return newState;
        }

        case addEditBillingGroupActionTypes.SETTING_BILLING_GROUP_FORM_OBJECT_VALUE: {
            let newState = _.cloneDeep(state);
            // reject character input/empty string
            if (action.payload.value === "") {
                newState.billingGroupObject[action.payload.name] = initialState.billingGroupObject[action.payload.name];
            } else {
                newState.billingGroupObject[action.payload.name] = action.payload.value;
            }
            return newState;
        }

        case addEditBillingGroupActionTypes.SETTING_BILLING_GROUP_FORM_DESCRIPTION: {
            let newState = _.cloneDeep(state);
            newState.billingGroupObject[action.payload.name] = action.payload.value;
            return newState;
        }

        case addEditBillingGroupActionTypes.TOGGLE_MODAL: {
            return initialState;
        }

        case addEditBillingGroupActionTypes.UPDATED_BILLING_GROUP_REFRESH:{
            let newState = _.cloneDeep(state);
            newState.updatedBillingGroup = !newState.updatedBillingGroup;
            return newState;
        }

        case addEditBillingGroupActionTypes.SET_BILLING_GROUP_TOGGLES: {
            let newState = _.cloneDeep(state);
            newState.billingGroupObject[action.payload.option] = !newState.billingGroupObject[action.payload.option];
            return newState;
        }

        case addEditBillingGroupActionTypes.SET_BILLING_GROUP_DROPDOWNS: {
            let newState = _.cloneDeep(state);

            if (action.payload.option === null) {
                newState.billingGroupObject[action.payload.change_obj.name] = initialState.billingGroupObject.billing_group_detail[action.payload.change_obj.name];
            } else {
                newState.billingGroupObject[action.payload.change_obj.name] = action.payload.option.value;
            }
            return newState;
        }

        case addEditBillingGroupActionTypes.SET_BILLING_GROUP_DATE: {
            let newState = _.cloneDeep(state);
            if (action.payload.day.day !== '') {
                newState.billingGroupObject.contract_start_date = action.payload.day.day;
            } else {
                newState.billingGroupObject.contract_start_date = null;
            }

            return newState;
        }

        default:
            return state;
    }
}

export default addEditBillingGroupReducer;
